export default function () {
    const $wbForm = $('.whistleblower');
    $wbForm.each((i) => {
        const $wbID = $wbForm[i].getAttribute('id');
        const $wbIDLink1 = $('#' + $wbID + '_link1').val();
        const $wbIDLink2 = $('#' + $wbID + '_link2').val();
        const $wbIDLinkDefault = $('#' + $wbID + '_linkDefault').val();
        const $wbIDLinktext1 = $('#' + $wbID + '_linktext1').val();
        const $wbIDLinktext2 = $('#' + $wbID + '_linktext2').val();
        const $wbIDLinktextDefault = $('#' + $wbID + '_linktextDefault').val();
        const $wbIDlink1UIDs = $('#' + $wbID + '_link1UIDs').val();
        const $wbIDlink2UIDs = $('#' + $wbID + '_link2UIDs').val();
        const $wbIDContent = document.getElementById($wbID + '_content');
        const $wbIDchannelselection = $('#' + $wbID + '_channelselection');

        $wbIDchannelselection.on('change', (event) => {
            const $wbIDlink1UIDsArray = $wbIDlink1UIDs.split(',');
            const $wbIDlink2UIDsArray = $wbIDlink2UIDs.split(',');
            const $clinicSelectID = event.target.value;
            if ($wbIDlink1UIDsArray.includes('' + $clinicSelectID)) {
                if ($wbIDLink1 !== '') {
                    $wbIDContent.innerHTML = '<p><a href="' + $wbIDLink1
                        + '" target="_blank">' + $wbIDLinktext1 + '</a></p>';
                } else {
                    $wbIDContent.innerHTML = '<p>' + $wbIDLinktext1 + '</p>';
                }
            } else if ($wbIDlink2UIDsArray.includes($clinicSelectID)) {
                if ($wbIDLink2 !== '') {
                    $wbIDContent.innerHTML = '<p><a href="' + $wbIDLink2
                        + '" target="_blank">' + $wbIDLinktext2 + '</a></p>';
                } else {
                    $wbIDContent.innerHTML = '<p>' + $wbIDLinktext2 + '</p>';
                }
            } else if ($clinicSelectID) {
                if ($wbIDLinkDefault !== '') {
                    $wbIDContent.innerHTML = '<p><a href="' + $wbIDLinkDefault
                        + '" target="_blank">' + $wbIDLinktextDefault + '</a></p>';
                } else {
                    $wbIDContent.innerHTML = '<p>' + $wbIDLinktextDefault + '</p>';
                }
            } else {
                $wbIDContent.innerHTML = '';
            }
        });
    });
}
